import { LeaveRequestApi, ToastStateHandler } from '../../../api';
import { LeaveRequestDto } from '../../../commonTypes/leaveRequest.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpEditOngoingLeaveRequest = () => {
    const { t } = useTranslation('leaveRequest');
    const leaveRequestApi: LeaveRequestApi = useContainer(LeaveRequestApi);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = (leaveRequest: LeaveRequestDto, newToDate: string, cb: (request: LeaveRequestDto) => void) => {
        const { exec, abort } = leaveRequestApi.editOngoingLeaveRequest({
            params: { id: leaveRequest.id },
            body: { newToDate },
            onSuccess: _ => {
                cb(leaveRequest);
                toastHandler.push(
                    'success',
                    t('notifications.editOnGointLeaveRequestTitle'),
                    t('notifications.editOnGointLeaveRequestSucceededMessage')
                );
            },
            onError: error => {
                console.log(error);
                toastHandler.push('error', t('notifications.editOnGointLeaveRequestTitle'), t('notifications.editOnGointLeaveRequestFailedMessage'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpEditOngoingLeaveRequest;
